{
  "interface": "Schnittstelle",
  "newInterface": "Neue Schnittstelle",
  "updateInterface": "Schnittstelle aktualisieren",
  "generateNewInterface": "Neue Schnittstelle generieren",
  "tabs": {
    "mobileApp": {
      "title": "Mobile Anwendung",
      "column": {
        "organizationName": "Organisationsname",
        "name": "Schnittstellenname",
        "deviceTypes": "Gerätetyp",
        "updatedAt": "Aktualisiert am"
      },
      "form": {
        "information": {
          "title": "Information",
          "organizationName": "Organisationsname",
          "name": "Name",
          "description": "Beschreibung"
        },
        "deviceTypes": {
          "title": "Eigenschaften der Gerätezeilen",
          "label": "Typen",
          "add": "Hinzufügen",
          "save": "Speichern",
          "cancel": "Abbrechen",
          "noLabel": "Unbekannter Typ"
        },
        "validation": {
          "name": "Der Schnittstellenname ist erforderlich",
          "nameFormat": "Der Schnittstellenname darf nur alphanumerische Zeichen oder Unterstriche enthalten",
          "uniqueName": "Der Schnittstellenname muss eindeutig sein"
        }
      },
      "empty": "Keine mobilen Anwendungen verfügbar"
    },
    "thirdPartyApp": {
      "title": "Drittanbieter-Anwendung",
      "column": {
        "organizationName": "Organisationsname",
        "interfaceName": "Schnittstellenname",
        "authMethod": "Authentifizierungsmethode",
        "profile": "Profil",
        "updatedAt": "Aktualisiert am",
        "status": "Status"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "authMethod": {
        "clientGrant": "Client-Grant",
        "mtls": "mTLS",
        "userCredentials": "Client-Anmeldedaten"
      },
      "form": {
        "title": "Information",
        "organizationName": "Organisationsname",
        "name": "Schnittstellenname",
        "profile": {
          "label": "Profil",
          "placeholder": "1 Profil auswählen"
        },
        "sectors": {
          "label": "Sektoren",
          "placeholder": "Sektoren auswählen"
        },
        "authenticationType": {
          "label": "Authentifizierungstyp",
          "clientGrant": "ClientGrant",
          "mtls": "mTLS"
        },
        "validation": {
          "organizationName": "Der Name der Organisation ist erforderlich",
          "name": "Der Name ist erforderlich",
          "profile": "Das Profil ist erforderlich",
          "sectors": "Die Auswahl eines oder mehrerer Sektoren ist erforderlich",
          "authenticationType": "Authentifizierungstyp ist erforderlich",
          "nameFormat": "Der Schnittstellenname darf nur alphanumerische Zeichen oder Unterstriche enthalten",
          "uniqueName": "Der Schnittstellenname muss eindeutig sein"
        },
        "update": {
          "sidePanelTitle": "Änderung der Drittanbieter-Schnittstelle",
          "information": {
            "title": "Wichtig",
            "content": "Wenn Sie Ihr Client-Secret verloren haben, löschen Sie bitte diese Schnittstelle und erstellen Sie eine neue"
          }
        },
        "confirmCancelUpdate": {
          "title": "Schnittstellenaktualisierung abbrechen",
          "message": "Möchten Sie die Aktualisierung der Schnittstelle wirklich abbrechen?"
        },
        "confirmCancelCreate": {
          "title": "Schnittstellenerstellung abbrechen",
          "message": "Möchten Sie die Erstellung der Schnittstelle wirklich abbrechen?"
        }
      },
      "creationModalSuccess": {
        "header": {
          "title": "Erfolg",
          "info": "Warnung: Bewahren Sie diese Informationen auf. Sie werden nicht mehr verfügbar sein, sobald diese Seite geschlossen wird."
        },
        "clientId": {
          "label": "ClientId"
        },
        "secret": {
          "label": "Secret"
        },
        "copyToClipboard": {
          "copied": "Kopiert",
          "buttonTitle": "In die Zwischenablage kopieren"
        }
      },
      "empty": "Keine Drittanbieteranwendungen verfügbar",
      "licenseMessage": {
        "disableNewInterface": "Das Limit Ihrer Lizenz wurde erreicht, die Schnittstellenerstellung ist deaktiviert.",
        "disableActivateInterface": "Das Limit Ihrer Lizenz wurde erreicht, die Schnittstellenaktivierung ist deaktiviert."
      }
    }
  },
  "action": {
    "delete": {
      "confirm": {
        "title": "Schnittstelle löschen",
        "message": "Schnittstelle {name} wird gelöscht."
      }
    },
    "deactivate": {
      "confirm": {
        "title": "Schnittstelle deaktivieren",
        "message": "Schnittstelle {name} wird deaktiviert."
      }
    },
    "activate": {
      "confirm": {
        "title": "Schnittstelle aktivieren",
        "message": "Die Schnittstelle {name} wird aktiviert."
      }
    }
  }
}
